import { sharedThemeProperties } from '../shared-theme-properties.js';
import { tokens } from './ds-tokens.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const { fontSizes, fontWeights, lineHeights } = sharedThemeProperties;
const palettes = {
  blue: {
    bg_light: "#EBF1FF",
    light: "#CEDDFF",
    tint_light: "#9CBBFF",
    tint_dark: "#6C99FF",
    primary: "#3A77FF",
    dark: "#1D3C81",
    bg_dark: "#17284E"
  },
  red: {
    bg_light: "#FFEEEA",
    light: "#FFD6C9",
    tint_light: "#FFAA9A",
    tint_dark: "#FF8169",
    primary: "#FF5636",
    dark: "#D02C0D",
    bg_dark: "#991801"
  },
  teal: {
    bg_light: "#E9FCFB",
    light: "#C8F8F6",
    tint_light: "#91F2ED",
    tint_dark: "#5AECE4",
    primary: "#23E5DB",
    dark: "#00A49F",
    bg_dark: "#085C5D"
  },
  yellow: {
    bg_light: "#FFFBEF",
    light: "#FFF6D9",
    tint_light: "#FFEDB2",
    tint_dark: "#FFE48D",
    primary: "#FFCE32",
    dark: "#D2B982",
    bg_dark: "#71674E"
  },
  gray: {
    white: "#FFFFFF",
    gray2: "#FAFBFB",
    gray3: "#F2F4F5",
    gray4: "#D8DFE0",
    gray5: "#7F9799",
    gray6: "#406367",
    charcoal: "#02282C"
  },
  transparent: "transparent"
};
const olxTheme = __spreadProps(__spreadValues({}, sharedThemeProperties), {
  appMaxWidth: "1238px",
  colors: {
    "background-global-primary": palettes.gray.white,
    "background-global-secondary": palettes.gray.gray3,
    "background-global-inverse": palettes.gray.charcoal,
    "background-brand-primary": palettes.gray.charcoal,
    "background-brand-primary-light": palettes.gray.gray5,
    "background-brand-secondary": palettes.teal.primary,
    "background-brand-secondary-light": palettes.teal.light,
    "background-brand-alternative": palettes.blue.primary,
    "background-brand-alternative-light": palettes.blue.tint_dark,
    "background-brand-tertiary": palettes.gray.gray4,
    "background-brand-chat-highlight": palettes.blue.light,
    "background-brand-fields-active": palettes.gray.gray3,
    "background-brand-fields-disabled": palettes.gray.gray2,
    "background-brand-fields-inverse": palettes.gray.white,
    "background-brand-confirmationScreen-success": palettes.teal.bg_light,
    "background-brand-confirmationScreen-warning": palettes.yellow.bg_light,
    "background-brand-confirmationScreen-error": palettes.red.bg_light,
    "text-brand-primary": palettes.gray.charcoal,
    "text-brand-alternative": palettes.blue.bg_light,
    "text-brand-highlight": palettes.teal.dark,
    "text-global-primary": palettes.gray.charcoal,
    "text-global-secondary": palettes.gray.gray6,
    "text-global-disabled": palettes.gray.gray5,
    "text-global-inverse": palettes.gray.white,
    "text-global-hightlight": palettes.gray.charcoal,
    "text-global-error": palettes.red.primary,
    "background-brand-disabled": palettes.gray.gray4,
    "background-brand-error": palettes.red.primary,
    "background-brand-highlight-primary": palettes.teal.primary,
    "background-brand-highlight-secondary": palettes.yellow.light,
    "background-brand-tooltip": palettes.blue.primary,
    "background-brand-inverse": palettes.gray.charcoal,
    "background-brand-notification-dot": palettes.yellow.primary,
    "background-brand-notification-warning": palettes.yellow.light,
    "background-brand-notification-error": palettes.red.light,
    "background-brand-notification-success": palettes.teal.light,
    "background-brand-notification-neutral": palettes.blue.light,
    "icon-brand-primary": palettes.gray.charcoal,
    "icon-brand-alternative": palettes.blue.primary,
    "icon-global-primary": palettes.gray.charcoal,
    "icon-global-secondary": palettes.gray.gray6,
    "icon-global-disabled": palettes.gray.gray5,
    "icon-global-inverse": palettes.gray.white,
    "icon-global-highlight": palettes.teal.primary,
    "icon-global-error": palettes.red.primary,
    "icon-global-chat-highlight": palettes.blue.primary,
    "borders-brand-primary": palettes.gray.charcoal,
    "borders-brand-secondary": palettes.teal.primary,
    "borders-brand-alternative": palettes.blue.bg_light,
    "borders-global-primary": palettes.gray.charcoal,
    "borders-global-secondary": palettes.gray.gray5,
    "borders-global-tertiary": palettes.gray.gray4,
    "borders-global-inverse": palettes.gray.white,
    "borders-global-highlight": palettes.blue.bg_light,
    "borders-global-error": palettes.red.primary
  },
  focusOutline: {
    outline: `${tokens.borderWidths.large} solid ${palettes.blue.primary}`,
    outlineOffset: "1px"
  },
  palettes,
  typography: {
    h1: {
      fontSize: fontSizes[40],
      fontWeight: fontWeights.medium,
      lineHeight: lineHeights[42],
      letterSpacing: "0.5px"
    },
    h2: {
      fontSize: fontSizes[32],
      fontWeight: fontWeights.medium,
      lineHeight: lineHeights[34]
    },
    h3: {
      fontSize: fontSizes[24],
      fontWeight: fontWeights.medium,
      lineHeight: lineHeights[26]
    },
    h4: {
      fontSize: fontSizes[20],
      fontWeight: fontWeights.medium,
      lineHeight: lineHeights[22]
    },
    p1: {
      fontSize: fontSizes[18],
      fontWeight: fontWeights.regular,
      lineHeight: lineHeights[24]
    },
    p2: {
      fontSize: fontSizes[16],
      fontWeight: fontWeights.regular,
      lineHeight: lineHeights[20]
    },
    p3: {
      fontSize: fontSizes[14],
      fontWeight: fontWeights.regular,
      lineHeight: lineHeights[18]
    },
    p4: {
      fontSize: fontSizes[12],
      fontWeight: fontWeights.regular,
      lineHeight: lineHeights[14]
    },
    p5: {
      fontSize: fontSizes[11],
      fontWeight: fontWeights.regular,
      lineHeight: lineHeights[14]
    },
    ln1: {
      fontSize: fontSizes[14],
      lineHeight: lineHeights[18],
      fontWeight: fontWeights.medium,
      letterSpacing: "0.8px",
      textTransform: "uppercase"
    },
    ln2: {
      fontSize: fontSizes[12],
      lineHeight: lineHeights[16],
      fontWeight: fontWeights.medium,
      letterSpacing: "0.8px",
      textTransform: "uppercase"
    }
  }
});

export { olxTheme };
